import { reduce, cloneDeep, snakeCase, isEqual } from 'lodash';
const moment = require('moment');
import { Moment } from 'moment';
interface CabinPrices {
  cabin1: number;
  cabin2: number;
  cabin3: number;
  cabin4: number;
}
export default class MonthlyReportController {
  newClientsFields = [
    'scheduledTests',
    'sessions',
    'proskin',
    'informationsOnly'
  ];
  loadingReports = false;
  showCashDeskReport = false;
  showNewClientsReport = true;
  showPulsesReport = false;
  list = [];
  reportList = [];
  serviceList = [];
  productList = [];
  selectedShop;
  selectedMonth;
  daysOfMonth = [];
  cabin1Present = false;
  cabin2Present = false;
  cabin3Present = false;
  cabin4Present = false;
  snakeCase: Function = snakeCase;
  customExec: String;
  cabinPrices: CabinPrices = {
    cabin1: 0.005,
    cabin2: 0.0015,
    cabin3: 0.005,
    cabin4: 0.0015
  };
  isViewer: boolean;
  /*@ngInject*/
  constructor(private DailyReport, private Configurations, private $http, private Auth) {
    this.$onInit();
  }

  $onInit() {
    // console.log('init');
    var vm = this;
    this.Configurations.query({ active: true }, ([config]) => {
      if (config && config.fileMonthlySelling) {
        vm.$http.get(config.fileMonthlySelling).then(
          function(data) {
            vm.customExec = data.data;
            var exec = function() {
              return {
                cabin1: 0.005,
                cabin2: 0.0015,
                cabin3: 0.005,
                cabin4: 0.0015
              };
            };
            if (vm.customExec) {
              eval(vm.customExec.toString());
            }
            vm.cabinPrices = exec();
          },
          function(error) {
            alert('error');
          }
        );
      }
    });
    this.Auth.getCurrentUser(user => {
      this.isViewer = user.role === 'viewer';
    });
  }

  shopSelected(shop, month) {
    // console.log('shop selected', cloneDeep(shop), month);
    this.loadingReports = true;
    this.selectedShop = cloneDeep(shop);
    this.selectedMonth = month;
    var startLastMonth = moment(month)
      .local()
      .startOf('month')
      .subtract(1, ' months')
      .format('YYYY-MM-DD');
    var endLastMonth = moment(month)
      .local()
      .endOf('month')
      .subtract(1, ' months')
      .format('YYYY-MM-DD');
    var startMonth = moment(month)
      .local()
      .startOf('month')
      .format('YYYY-MM-DD');
    var endMonth = moment(month)
      .local()
      .endOf('month')
      .format('YYYY-MM-DD');
    this.list = [];
    this.DailyReport.query({ id: shop._id, endMonth, startMonth }, result => {
      // console.log('reports', result);
      this.list = result;
      this.DailyReport.query(
        {
          id: shop._id,
          endMonth: endLastMonth,
          startMonth: startLastMonth,
          limit: 1
        },
        ([lastMonthReport]) => {
          if (lastMonthReport) {
            this.list.splice(0, 0, lastMonthReport);
          }
          this.initAll();
          this.loadingReports = false;
        }
      );
    });
  }

  getServiceList() {
    var result = [];
    this.list.forEach(report => {
      report.services.forEach(service => {
        if (!result.find(e => e._id == service.service._id)) {
          result.push(service.service);
        }
      });
    });
    return result;
  }
  initAll() {
    this.initDays(this.selectedMonth);
    this.initReportList();
    this.initServiceList();
    this.initProductList();
  }
  getReportFor(day) {
    let report = this.reportList.find(e => {
      let res = (<Moment>moment(e.date)).isSame(day);
      // console.log('report',  'for day', e.date, 'matches day', day.format('YYYY-MM-DD'), '?', res);
      return res;
    });
    // console.log('found report', report, 'for day', day.format('YYYY-MM-DD'));
    return report;
  }
  initDays(month) {
    this.daysOfMonth = [];
    var lastReport = this.list[this.list.length - 1];
    var lastDate = moment(lastReport.date)
      .local()
      .add(2, 'days');
    // console.log('last report', lastDate.format('YYYY-MM-DD'));
    for (
      var day = moment(month)
        .local()
        .startOf('month');
      (<Moment>day).diff(lastDate, 'days') <= 0;
      day.add(1, 'days')
    ) {
      this.daysOfMonth.push(moment(day).startOf('day'));
    }
  }
  initReportList() {
    var lastReports = [];
    var totalReports = [];
    this.reportList = [];
    this.daysOfMonth.forEach(day => {
      // console.log('day', day.format('YYYY-MM-DD'))

      let report = this.list.find(e => moment(e.date).isSame(day));
      if (report) {
        let reportIndex = this.list.indexOf(report);
        // console.log('report found', reportIndex);
        if (reportIndex > 0) {
          report.startCabin1Pulse = this.list[reportIndex - 1].cabin1Pulse;
          report.startCabin2Pulse = this.list[reportIndex - 1].cabin2Pulse;
          report.startCabin3Pulse = this.list[reportIndex - 1].cabin3Pulse;
          report.startCabin4Pulse = this.list[reportIndex - 1].cabin4Pulse;
        } else {
          report.startCabin1Pulse = 0;
          report.startCabin2Pulse = 0;
          report.startCabin3Pulse = 0;
          report.startCabin4Pulse = 0;
        }
        this.cabin1Present = this.cabin1Present || report.cabin1Pulse > 0;
        this.cabin2Present = this.cabin2Present || report.cabin2Pulse > 0;
        this.cabin3Present = this.cabin3Present || report.cabin3Pulse > 0;
        this.cabin4Present = this.cabin4Present || report.cabin4Pulse > 0;
        lastReports.push(report);
        this.reportList.push(report);
      } else if (lastReports.length > 0) {
        // console.log('lastReports found')
        var total = {
          date: day.format('YYYY-MM-DD'),
          services: [],
          products: [],
          startCabin1Pulse: 0,
          cabin1Pulse: 0,
          startCabin2Pulse: 0,
          cabin2Pulse: 0,
          startCabin3Pulse: 0,
          cabin3Pulse: 0,
          startCabin4Pulse: 0,
          cabin4Pulse: 0,
          type: 'total'
        };
        this.newClientsFields.forEach(field => {
          total[field] = 0;
        });

        lastReports.forEach(report => {
          report.services.forEach(service => {
            var totalService = total.services.find(s =>
              isEqual(s.service.name, service.service.name)
            );
            if (totalService) {
              totalService.quantity += service.quantity;
            } else {
              total.services.push(cloneDeep(service));
            }
          });
          report.products.forEach(product => {
            // debugger;
            var totalProduct = total.products.find(s =>
              isEqual(s.product.name, product.product.name)
            );
            // console.log(report.date, 'product name', product.product.name, product.quantity, 'equals', 'Em 250 ml, current', isEqual(product.product.name, 'Em 250 ml'), totalProduct ? totalProduct.quantity: 'n/a')
            if (totalProduct) {
              totalProduct.quantity += product.quantity;
            } else {
              total.products.push(cloneDeep(product));
            }
          });
          this.newClientsFields.forEach(field => {
            total[field] += report[field];
          });

          total.startCabin1Pulse += report.startCabin1Pulse;
          total.cabin1Pulse += report.cabin1Pulse;

          total.startCabin2Pulse += report.startCabin2Pulse;
          total.cabin2Pulse += report.cabin2Pulse;

          total.startCabin3Pulse += report.startCabin3Pulse;
          total.cabin3Pulse += report.cabin3Pulse;

          total.startCabin4Pulse += report.startCabin4Pulse;
          total.cabin4Pulse += report.cabin4Pulse;
        });
        this.reportList.push(total);
        totalReports.push(total);
        lastReports = [];
      } else if (totalReports.length > 0) {
        // console.log('lastReports not found')
        this.reportList.push(this.calculateReportsTotal(day, totalReports));
      }
    });
  }
  calculateReportsTotal(day: Moment, reports = []) {
    var total = {
      date: day.format('YYYY-MM-DD'),
      services: [],
      products: [],
      startCabin1Pulse: 0,
      cabin1Pulse: 0,
      startCabin2Pulse: 0,
      cabin2Pulse: 0,
      startCabin3Pulse: 0,
      cabin3Pulse: 0,
      startCabin4Pulse: 0,
      cabin4Pulse: 0,
      type: 'total'
    };
    this.newClientsFields.forEach(field => {
      total[field] = 0;
    });
    reports.forEach(report => {
      report.services.forEach(service => {
        var totalService = total.services.find(s =>
          isEqual(s.service.name, service.service.name)
        );
        if (totalService) {
          totalService.quantity += service.quantity;
        } else {
          total.services.push(cloneDeep(service));
        }
      });
      report.products.forEach(product => {
        var totalProduct = total.products.find(s =>
          isEqual(s.product.name, product.product.name)
        );
        if (totalProduct) {
          totalProduct.quantity += product.quantity;
        } else {
          total.products.push(cloneDeep(product));
        }
      });
      this.newClientsFields.forEach(field => {
        total[field] += report[field];
      });

      total.startCabin1Pulse += report.startCabin1Pulse
        ? report.startCabin1Pulse
        : 0;
      total.cabin1Pulse += report.cabin1Pulse ? report.cabin1Pulse : 0;

      total.startCabin2Pulse += report.startCabin2Pulse
        ? report.startCabin2Pulse
        : 0;
      total.cabin2Pulse += report.cabin2Pulse ? report.cabin2Pulse : 0;

      total.startCabin3Pulse += report.startCabin3Pulse
        ? report.startCabin3Pulse
        : 0;
      total.cabin3Pulse += report.cabin3Pulse ? report.cabin3Pulse : 0;

      total.startCabin4Pulse += report.startCabin4Pulse
        ? report.startCabin4Pulse
        : 0;
      total.cabin4Pulse += report.cabin4Pulse ? report.cabin4Pulse : 0;
    });
    return total;
  }
  initServiceList() {
    this.serviceList = [];
    this.list.forEach(report => {
      report.services.forEach(service => {
        if (
          !this.serviceList.find(e => isEqual(e.name, service.service.name))
        ) {
          this.serviceList.push(service.service);
        }
      });
    });
  }
  initProductList() {
    this.productList = [];
    this.list.forEach(report => {
      report.products.forEach(product => {
        if (
          !this.productList.find(e => isEqual(e.name, product.product.name))
        ) {
          this.productList.push(product.product);
        }
      });
    });
  }

  getSelledServiceQuantity(report, service, day) {
    if (report) {
      let quantity = report.services
        .filter(e => isEqual(e.service.name, service.name))
        .reduce((total, current) => total + current.quantity, 0);
      return quantity;
    }
  }
  getSelledProductQuantity(report, product, day) {
    if (report) {
      let quantity = report.products
        .filter(e => {
          return isEqual(e.product.name, product.name);
        })
        .reduce((total, current) => total + current.quantity, 0);
      return quantity;
    }
  }
  getReportServicesProductsTotal(report) {
    var total = 0;
    this.serviceList.forEach(service => {
      var serviceRef = report.services.find(s =>
        isEqual(s.service.name, service.name)
      );
      if (serviceRef) {
        total += serviceRef.service.price * serviceRef.quantity;
      }
    });
    this.productList.forEach(product => {
      var productRef = report.products.find(s =>
        isEqual(s.product.name, product.name)
      );
      if (productRef) {
        total += productRef.product.price * productRef.quantity;
      }
    });
    return total;
  }
  selectCashDeskReport() {
    this.showCashDeskReport = true;
    this.showNewClientsReport = false;
    this.showPulsesReport = false;
  }
  selectNewClientsReport() {
    this.showCashDeskReport = false;
    this.showNewClientsReport = true;
    this.showPulsesReport = false;
  }
  selectPulsesReport() {
    this.showCashDeskReport = false;
    this.showNewClientsReport = false;
    this.showPulsesReport = true;
  }
  getTitleColSpan() {
    if (this.showCashDeskReport) {
      return this.serviceList.length + this.productList.length;
    } else if (this.showNewClientsReport) {
      return 5;
    } else if (this.showPulsesReport) {
      return 16;
    }
    return 0;
  }
  getNewClientsTotal(report) {
    return (
      report.scheduledTests +
      report.sessions +
      report.proskin +
      report.informationsOnly
    );
  }
}



// WEBPACK FOOTER //
// ./client/app/manager/monthlySelling/monthlySelling.controller.ts